import AdminOrdersPanel from "./AP_Orders"
import Products from "./AP_Products"
import Categories from "./AP_Categories"
import Users from "./AP_Users"
import SignUpEditor from "./AP_SignUp"
import InquiriesPanel from "./AP_Inquiries"

const AdminPanelTabs = (props) => {
  const tab = props.tab

  console.log("🧭 CURRENT TAB:", tab)

  if (tab === "orders") {
    console.log("✅ RENDERING ORDERS PANEL")
    return <AdminOrdersPanel />
  } else if (tab === "products") {
    return <Products />
  } else if (tab === "products_new") {
    return <Products />
  } else if (tab === "categories") {
    return <Categories />
  } else if (tab === "users") {
    return <Users />
  } else if (tab === "signup") {
    return <SignUpEditor />
  } else if (tab === "inquiries") {
    return <InquiriesPanel onCountChange={props.onInquiryCount} />
  } else {
    console.log("❌ NO MATCHING TAB")
    return <>Error: No Tab Rendered</>
  }
}

export default AdminPanelTabs
